import React from "react";
import Router from "./routers/Router";
import "./styles/main.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AuthProvider } from "./context/authContext";
import toast , { Toaster } from "react-hot-toast";

function App() {
  return (
    <div>
      <AuthProvider>
        <Router />
      </AuthProvider>
      <Toaster
        toastOptions={{
          style: {
            padding: "30px",

            fontSize: "16px",
            zIndex:"99999999"
          }
        }}
      />
    </div>
  );
}

export default App;
